module.exports = __webpack_public_path__ + "img/3-5.6872d2e1.svg";